/**
 * Button Component
 *
 */

import IconPrimary from './IconPrimary'
export default IconPrimary
export * from './IconPrimary'
